import { useMarketStore } from '@/store/use-markets-store';
import { useWebSocketStore } from '@/store/use-websocket-store';
import { cn } from '@/utils/cn';
import { abbrFromSym } from '@/utils/token-symbol';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from 'zustand';

type Props = {
  symbol: string;
};

export default function Symbol({ symbol }: Props) {
  const priceChange = useStore(
    useMarketStore(symbol),
    (state) => state.marketData.priceChange,
  );

  useEffect(() => {
    const { increaseDependenciesForSymbol, decreaseDependenciesForSymbol } =
      useWebSocketStore.getState();
    increaseDependenciesForSymbol(symbol);
    return () => decreaseDependenciesForSymbol(symbol);
  }, [symbol]);

  return (
    <Link to={`/trade/${symbol}`} className="flex items-center gap-2">
      <div
        className={cn('h-5 w-1 shrink-0 rounded', {
          'bg-green': priceChange > 0n,
          'bg-red': priceChange < 0n,
          'bg-vestgrey-100': priceChange === 0n,
        })}
      />
      {abbrFromSym(symbol)}
    </Link>
  );
}
